import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { UserTicketDto } from '../../../data/models/user-ticket-dto';
import { DialogService } from '../../../services/dialog.service';
import { TicketsService } from '../../../services/tickets.service';
import { ManualTicketResult } from '../../../data/models/manual-ticket-result';

@Component({
  selector: 'app-create-ticket',
  templateUrl: './create-ticket.component.html',
  styleUrls: ['./create-ticket.component.scss'],
  providers: [ConfirmationService,MessageService]
})
export class CreateTicketComponent implements OnInit {
  issueDesc: string;
  @Input() lineSummary: CcLineSummaryDto;
  @Output() closeTicketsDialog = new EventEmitter<ManualTicketResult>();
  isBtnLoading: boolean = false;
  ticketToAdd: UserTicketDto = new UserTicketDto();
  issuesOptions: SelectItem[] = [
    { label: 'Line unstable', value: '2003' },
    { label: 'Line Down', value: '2004' },
    { label: 'Slow Browsing', value: '2006' },
    { label: 'VPN Blocking', value: '2008' },
    { label: 'No Browsing', value: '2009' },
    { label: 'Reason For Outage', value: '2073' },
  ];
  userNameIsValid: boolean = true;
  userPhoneIsValid: boolean = true;
  userEmailIsValid: boolean = true;
  errorDesc: string;
  srNumber: string;
  showSRNumberDilaog: boolean = false;
  constructor(private confirmService: ConfirmationService,
    private messageService: MessageService, private ticketService: TicketsService, private dialogService: DialogService) { }

  ngOnInit(): void {
  }

  IsInvalidIssueDesc() {
    if (this.issueDesc) return false;
      else return true;
  }

  submitTicket() {
    if (!this.checkValidation()) {
      return;
    }
    this.isBtnLoading = true;
    this.ticketToAdd.accountId = this.lineSummary.accountId;
    this.ticketToAdd.lineId = this.lineSummary.id;
    this.ticketToAdd.lineName = this.lineSummary.name;
    this.ticketToAdd.lineQuoteId = this.lineSummary.quoteID;
    if (!this.ticketToAdd.notes || this.ticketToAdd.notes == undefined) {
      this.ticketToAdd.notes = null;

    }
    console.log("this.ticketToAdd =", this.ticketToAdd);
    this.confirmTicketCreation(this.ticketToAdd);
  }
  validateUserName(): boolean{
    let userNameAllowedLength = 8;

    if (this.ticketToAdd.name && typeof this.ticketToAdd.name === 'string' && this.ticketToAdd.name.trim() !== '') {
      if (this.ticketToAdd.name.trim().length === 0 || this.ticketToAdd.name.length < userNameAllowedLength) {
        return false; 
      }
      return true; 
    }
    return false; 
  }

  validateUserEmail(): boolean{
    if (this.ticketToAdd.email && typeof this.ticketToAdd.email === 'string' && this.ticketToAdd.email.trim() !== '') {
      if (/^\s*$/.test(this.ticketToAdd.email)) {
        return false; 
      }
      // Validate email format using a regular expression
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.ticketToAdd.email.trim()); // Returns true if email format is valid, false otherwise
    }
    return false; 
  }
  validateUserPhoneNumber(): boolean{
    if (!this.ticketToAdd.phone) {
      return false;
    }
    let phoneNumberString: string = this.ticketToAdd.phone.toString();

    const numericPhoneNumber = phoneNumberString.replace(/\D/g, '');

    
    const phoneNumberLength = numericPhoneNumber.length;
    return phoneNumberLength >= 8 && phoneNumberLength <= 13;
    

  }
  checkValidation() {
    this.userEmailIsValid = this.validateUserEmail();
    this.userNameIsValid = this.validateUserName();
    this.userPhoneIsValid = this.validateUserPhoneNumber();
    if (this.userEmailIsValid && this.userNameIsValid && this.userPhoneIsValid) {
      return true;
    }
    return false;
  }

  confirmTicketCreation(ticket) {
    this.isBtnLoading = false;
    this.confirmService.confirm({
      message: 'Are you sure you want to create this ticket ?',
      accept: () => {
        this.createNewTicket(ticket);
      }
    });
  }
  createNewTicket(ticktet) {
    this.ticketService.createNewTicket(ticktet).subscribe((res: any) => {
      if (res) {
        //console.log("create new ticket result =", res);
       
       if (res.success && res.data && res.data.errorDescription && res.data.srNumber) {
          
          this.closeDialogWithSuccess(res.data.errorDescription, res.data.srNumber);
        }

        else {
          this.closeDialogWithError('Unable to create new ticket for this line.');
        }
      }
      else {
        

        this.closeDialogWithError('Unable to create new ticket for this line.');
      
      }
    }, (error) => {
      if (error.error.data.errorCode == 500 && error.error.data.srNumber == null
        && error.error.data.errorDescription == "The same values for 'Name' already exist.\n\nIf you would like to enter a new record, please ensure that the field values are unique.(SBL-DAT-00382)"
      ) {
        this.closeDialogWithError("This line has opened ticket with the same issue.");
      } 
      else {
        this.closeDialogWithError('Unable to create new ticket for this line.');

      }
     

    }
    )
  }
  closeDialogWithSuccess(errorDesc,srNumber) {
    let ticketSuccessResult = new ManualTicketResult();
    ticketSuccessResult.isSuccess = true;
    ticketSuccessResult.resultDescription = errorDesc;
    ticketSuccessResult.srNumber = srNumber;
    this.closeTicketsDialog.emit(ticketSuccessResult);
  }
  closeDialogWithError(errorDesc) {
    let ticketResult = new ManualTicketResult();
    ticketResult.isSuccess = false;
    ticketResult.resultDescription = errorDesc;
    this.closeTicketsDialog.emit(ticketResult);
  }
}
